export default {
currency_code: "QAR",
offers: "Offers",
manage_offers: "Manage your offers",
add_offer: "Add Offer",
offer_id: "Offer ID",
validity: "Validity",
offer_type: "Offer Type",
no_offers: "No offers created yet",
category_offer: "Category Offer",
active: "Active",
expired: "Expired",
upcoming: "Upcoming",
starts_in: "Starts in",
ending_in: "Ending in",
min: "min",
edit: "Edit",
  "create_offer": "Create Offer",
  "update_offer": "Update Offer",
  "category_offer": "Category Offer",
  "product_offer": "Product Offer",
  "category": "Category",
  "sub_category": "Sub Category",
  "select_category": "Select Category",
  "deactivate_offer": "Deactivate this offer",
  "products_selected": "products selected",
  "select_products": "Select Products",
  "discount_type": "Discount Type",
  "discount_percentage": "Discount (%)",
  "flat_amount": "Flat Amount",
  "buy_qty": "Buy Qty",
  "get_qty": "Get Qty",
  "free_delivery": "Enable Free Delivery",
  "start_date": "Start Date",
  "end_date": "End Date",
  "start_time": "Start Time",
  "end_time": "End Time",
  "offer_title": "Offer Title",
  "description": "Description",
  "save_offer": "Save Offer",
  "missing_date_range": "Missing date range",
  "set_featured": "Set as Featured Offer",
  search_offer: "Search Offer",
status: "Status",
all: "All",
inactive: "Inactive",
today: "Today",
action: "Action",
search: "Search",
offers_found: "offers found",
Type:"Offer Type",
valid:"Offer Valid",
}